<template>
<div class="search-member">
        <transition :name="transition">
            <div v-show="show" class="member-container" ref="memberContainer" id="memberContainer">
                <div class="loading" v-show="loading">
                    <img src="@/assets/h5/loading2.gif">
                </div>
                <div v-show="data.length > 0" class="member-content data" ref="memberList">
                    <div class="member-list" v-for="(item, index) in data" :key="index" @click="selectMember(item)">
                        <Member :data="item"></Member>
                    </div>
                </div>
                <div v-show="data.length <= 0 && !loading" class="member-content no-data">
                    <span class="no-data-tip">{{$t("未能找到相关结果#!!!#src/pages/H5/Cloud/components/share/FileShareSearchView.vue_1")}}</span>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import Member from './FileShareSearchMember.vue';
import { searchMember } from "@/api/h5/file";
import { getMemberAvatar } from "@/utils/avatar";

export default {
  name: "FileShareSearchMember",
  components: {
    Member
  },
  props: {
    transition: {
      type: String,
      default: 'fade-in-linear'
    },
    reference: {},
    searchText: {
      type: String,
      default: ''
    },
    originData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      data: []
    };
  },
  watch: {
    searchText: {
      handler(val) {
        if (val) {
          this.show = this.loading = true;
          this.querySearchMember();
        } else {
          this.show = this.loading = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    querySearchMember() {
      // TODO: 这里将替换为新接口
      this.data = [];
      searchMember(this.searchText, true).then((res) => {
        if (res.data.searchKey !== this.searchText) {
          this.loading = false;
          return;
        }
        if (!res.success) {
          this.loading = false;
          return;
        }
        const { members = [] } = res.data;
        this.handlerContacts(members);
        this.loading = false;
        let $el = document.getElementById('memberContainer');
        if (members.length === 0) {
          if ($el) {
            $el.style.height = '36px';
          }
        } else {
          if ($el) {
            if (members.length < 6) {
              $el.style.height = members.length * 49 + 8 + 'px';
            } else {
              $el.style.height = '300px';
            }
          }
          this.$nextTick(() => {
            this.$refs.memberList.scrollTo(0, 0);
          });
        }
      }).catch((err) => {
        this.loading = false;
      });
    },
    async handlerContacts(memberList) {
      const result = [];
      memberList.map((user) => {
        const { departments = [] } = user;
        let department_name = '';
        let spaceName = '';
        if (departments) {
          for (var i = 0; i < departments.length; i++) {
            let depart = departments[i];
            if (i === 0) {
              spaceName = depart.departmentName;
            }
            department_name += depart.departmentName;
            if (i < departments.length - 1) {
              department_name += '/';
            }
          }
          if (department_name.length >= 25) {
            department_name = department_name.substring(0, 12) +
            '...' +
            department_name.substring(
              department_name.length - 12,
              department_name.length
            );
          }
        }

        let currentAuth = '';
        for (let i = 0; i < this.originData.length; i++) {
          if (this.originData[i].to === user.userId && this.originData[i].toSpace === user.spaceId) {
            currentAuth = this.transAuthToText(this.originData[i].auth);
            break;
          }
        }

        result.push({
          memberName: user.memberName,
          userId: user.userId,
          spaceId: user.spaceId,
          spaceName: spaceName,
          memberAvatar: getMemberAvatar(user.memberAvatar)['100'],
          departmentName: department_name,
          id: user.id,
          currentAuth: currentAuth
        });
      });
      this.data = this.data.concat(result);
    },
    selectMember(item) {
      this.show = false;
      this.$emit('selectMember', item);
    },
    getSearchMemberRect(isShow) {
      let searchMember = document.querySelector('#memberContainer');
      let rect = searchMember.getBoundingClientRect();
      if (isShow) {
        this.$refs.memberContainer.style.top = `${rect.top + 40}px`;
      } else {
        this.$refs.memberContainer.style.top = `${rect.top - 40}px`;
      }
    },
    transAuthToText(auth) {
      switch (auth) {
        case 'READ':
          return intl.$t("仅查看#!!!#src/pages/H5/Cloud/components/share/FileShareSearchView.vue_1");
        case 'READ_DOWNLOAD':
          return intl.$t("查看下载#!!!#src/pages/H5/Cloud/components/share/FileShareSearchView.vue_1");
        case 'WRITE':
          return intl.$t("编辑#!!!#src/pages/H5/Cloud/components/share/FileShareSearchView.vue_1");
        case 'ALL':
          return intl.$t("所有#!!!#src/pages/H5/Cloud/components/share/FileShareSearchView.vue_1");
      }
    }
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.search-member {
    position: absolute;
    top: 40px;
    width: 100%;
    height: 0px;
    display: inline-flex;
    flex: 1;

    .member-container {
        width: 368px;
        height: 300px;
        transition: height 0.3s;
        background: #FFFFFF;
        border: 1px solid #E6E8EC;
        box-sizing: border-box;
        box-shadow: 0 8px 12px 0 #1213171a;
        border-radius: 8px;
        position: absolute;
        top: 0px;
        left: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2000;

        .loading {
            img {
                width: 24px;
                height: 24px;
            }
        }

        .member-content {
            width: 100%;
            height: 100%;
            margin: 0 4px 0 0;

            &.data {
                overflow-x: hidden;
                overflow-y: auto;

                .member-list {
                    margin: 4px 4px 0px 4px;
                    height: 45px;
                    cursor: pointer;

                    &:hover {
                        background: #F4F6F9;
                        border-radius: 8px;
                    }
                }

                &::-webkit-scrollbar {
                    width: 4px;
                    border-radius: 3px;
                }

                &::-webkit-scrollbar-thumb {
                    cursor: pointer;
                    background: #DCDDDE;
                    border-radius: 3px;
                    transition: 0.3s background-color;
                }

                &::-webkit-scrollbar-track {
                    opacity: 0;
                    transition: opacity 120ms ease-out;
                }
            }

            &.no-data {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .no-data-icon {
                    width: 175px;
                    height: 116px;
                    margin-bottom: 12px;
                }

                .no-data-tip {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #646573;
                    line-height: 20px;
                }
            }
        }
    }

}
</style>
